var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 pl-4"
  }, _vm._l(_vm.logs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "vertical-line"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "pl-3 content-log"
    }, [_c('strong', [_vm._v(_vm._s(item[_vm.namekey]))]), _c('div', {
      staticClass: "d-flex align-items-center mb-1 text-blue-400"
    }, [_c('i', {
      staticClass: "fa fa-calendar-alt mr-2"
    }), _c('p', {
      staticClass: "text-sm mb-0"
    }, [_vm._v(_vm._s(_vm.formatDateOrValue(item[_vm.datekey])))])]), _c('small', [_vm._v(_vm._s(item[_vm.descriptionkey]))])])]);
  }), 0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "dot"
  })]);

}]

export { render, staticRenderFns }